import { useAppRouter } from '@/common/route/useAppRouter';
import { useCrudActions } from '@/common/view/useCrudActions';
import { updateValidator } from '@/modules/game/match/model/validator';
import { ROUTE_NAME_GAME } from '@/modules/game/router';
import { gameService } from '@/services/game';
import useVuelidate from '@vuelidate/core';
import { useMixins } from './mixins';

export function useGameMatchEdit() {
    const router = useAppRouter();
    const crudAction = useCrudActions();

    const { model } = useMixins();

    const v$ = useVuelidate(updateValidator, model);

    const actions = {
        update: crudAction.excuteAndNotify({
            validator: v$,
            request: () =>
                gameService.match.update(
                    model.id,
                    model.name,
                    model.levelTimeout,
                    model.findingMatchTimeout,
                    model.winLoseGroup,
                    model.allowInvitation,
                    model.costs,
                    model.costStates,
                    model.potRatePercents,
                    model.potRateWeights
                ),
            onSuccess: () => router.push({ name: ROUTE_NAME_GAME.MATCH.INDEX, query: { variantId: model.variantId } })
        }),
        remove: crudAction.confirmAndRemove({
            request: () => gameService.match.remove(model.id),
            onSuccess: () => router.push({ name: ROUTE_NAME_GAME.MATCH.INDEX, query: { variantId: model.variantId } })
        })
    };

    return { model, v$, actions };
}
